module.exports = __webpack_public_path__ + "img/yetToStart.d480569f.svg";